import { action } from "satcheljs";

export const setupSelectedRequestConflicts = action(
    "SETUP_SELECTED_REQUEST_CONFLICTS",
    () => ({})
);
